export default class VideoPopup {

	static selector = 'videoPopupModal';

	// class variables

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctaClose: container.querySelector(`.${this.constructor.selector}__cta-close`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		this.el.ctaClose.addEventListener('click', this.#onCtaCloseClick);
	}

	// listener methods

	#onCtaCloseClick = () => {
		this.close();
	}

	close() {
		this.el.container.classList.add('is-closed');
	}

}
